export default "__VITE_ASSET__CZErVcny__"